<div class="header-search-input-container" outsideClick (outsideClick)="hideMenu()">
    <div class="header-search-input">
        <span class="header-search-input__icon icon-Property-3search"></span>
        <input class="header-search-input__control" [formControl]="filterTextControl"
            placeholder="Search by order, shipment, or Item" (focus)="openMenu()" />
        <span class="header-search-input__icon">
            <span class="position-relative">
                <ngx-spinner type="ball-clip-rotate" size="small" color="#5ba7ea" name="search-input-loading"
                    [fullScreen]="false"></ngx-spinner>
            </span>
        </span>
    </div>

    <ng-container *ngIf="searchResults$ | async; let data">
        <div class="header-search-popup" *ngIf="data" [hidden]="!isOpened">
            <div class="header-search-list" *ngIf="data.groups.length; else emptyListTmpl">
                <div class="header-search-list-group" *ngFor="let group of data.groups">
                    <div class="header-search-list-group__header" *ngIf="group.items.length > 0">
                        {{ group.name | localize }}
                    </div>

                    <a class="header-search-list-item" [routerLink]="item.url" *ngFor="let item of group.items"
                        (click)="hideMenu()">
                        <span class="header-search-list-item__icon" [ngClass]="item.icon"></span>
                        <span class="header-search-list-item__text" [appHighlightText]="item.name"
                            [highlight]="data.searchText" [ignoreCase]="true"></span>
                    </a>
                </div>
            </div>

            <ng-template #emptyListTmpl>
                <div class="header-search-popup-no-results">
                    <span class="header-search-popup-no-results__icon icon-mirror-y icon-Property-3emoji-sad"></span>
                    <span class="header-search-popup-no-results__text">
                        Sorry, we didn't find any matches for "{{data.searchText}}"
                    </span>
                </div>
            </ng-template>
        </div>
    </ng-container>
</div>
